const React = require('react');
const Link = require('react-router-dom').Link;

exports.Intro = class Intro extends React.Component{
   constructor(props) {
      super(props);
      this.state = {

      }
   }

   render() {
      return (
         <div className='container-fluid intro-container'>
            <h4>
               Welcome to Polyplexus.
            </h4>
            <p>
               You’re not here by accident.
            </p>
            <p>
               You’re curiosity-driven with a real interest in late-breaking science and rigorous cross-disciplinary explorations. Your
               work is important, focused on asking the questions that will shape our future.
            </p>
            <p>
               Polyplexus is a modern platform designed to promote, connect, and support experts like you and research, with a
               structure that rapidly builds from current domain knowledge to new concepts and proposal development. And we’re
               linking researchers and research sponsors to dramatically accelerate the process.
            </p>
            <p>
               You are invited to join Polyplexus as a Founding Member, to help populate the initial foundation of scientific evidence
               upon which this platform will be based.
            </p>
            <p>
               Our goal? 3,500 pieces of reviewed evidence in the next 60 days, at which point the next release and new features will
               launch.
            </p>
            <p>
               For publishing at least ten pieces of evidence and reviewing thirty submitted pieces of evidence you will receive
               Founding Member status on the platform. For fully participating in this pilot program you will be able to compete for
               $300,000 in government research funding in the summer of 2018.
            </p>
            <p>
               This pre-alpha release is the first step in a journey toward increased research productivity. Upcoming releases will
               include the ability to link evidence, form teams and easily synthesize robust bodies of thought into clear proposals.
            </p>
            <p>
               Thank you for shaping this platform with your thoughts and feedback. You are key to creating an updated approach to
               scientific collaboration and our common future.
            </p>
            <br />
            <Link to="/">
               <button id='btnFinishInto' className='btn btn-primary' >Continue</button>
            </Link>

         </div>
      );
   }
};
